import React from "react";
// import App from "./App";
import { Link } from "react-router-dom";
function Navbar() {
  return (
    <>
      <div id="preloader">
        <div className="preloader">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <header className="navigation fixed-top">
        <div>
          <nav className="navbar navbar-expand-lg navbar-light">
            <Link className="navbar-brand logo navbar-light" to="/">
              

              <img
                
                style={{ width: 350, marginTop: -5, marginLeft: -9 }}
                src="images/macrozion_horizontal_logo.png"
                alt="logo"
              />
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navigation"
              aria-controls="navigation"
              aria-expanded="false"
              aria-label="toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navigation">
              <ul className="navbar-nav ml-auto text-center">
                
                <li className="nav-item ">
                  <Link className="nav-link" to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/about">
                    About Us
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/services">
                    Services
                  </Link>
                </li>
                
                <li className="nav-item ">
                  <Link className="nav-link" to="/career">
                    Career
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/contact">
                    Contact us
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="nav-link" to="/enquiry">
                    Enquiry
                  </Link>
                </li>
                <li className="nav-item ">
                  <a className="nav-link" href="tel:+9665433121">
                    +91-9665433121
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Navbar;
